// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as CountryConfig from "../../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as CountryContext from "../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as OrderFareTableVm from "./vm-mappers/OrderFareTableVm.bs.js";
import * as TableComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";

function getTableColumnsSchema(param) {
  return {
          hd: {
            column: {
              TAG: /* Text */0,
              _0: "Fare Type"
            },
            accessor: (function (f) {
                return {
                        TAG: /* Text */0,
                        _0: f.fare_type
                      };
              })
          },
          tl: {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Base Fare"
              },
              accessor: (function (f) {
                  return {
                          TAG: /* Text */0,
                          _0: f.base_fare
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "Waiting Time"
                },
                accessor: (function (f) {
                    return {
                            TAG: /* Text */0,
                            _0: f.waiting_time
                          };
                  })
              },
              tl: {
                hd: {
                  column: {
                    TAG: /* Text */0,
                    _0: "Travel Distance"
                  },
                  accessor: (function (f) {
                      return {
                              TAG: /* Text */0,
                              _0: f.travel_distance
                            };
                    })
                },
                tl: {
                  hd: {
                    column: {
                      TAG: /* Text */0,
                      _0: "Distance Charge"
                    },
                    accessor: (function (f) {
                        return {
                                TAG: /* Text */0,
                                _0: f.distance_charge
                              };
                      })
                  },
                  tl: {
                    hd: {
                      column: {
                        TAG: /* Text */0,
                        _0: "Travel Duration"
                      },
                      accessor: (function (f) {
                          return {
                                  TAG: /* Text */0,
                                  _0: f.travel_duration
                                };
                        })
                    },
                    tl: {
                      hd: {
                        column: {
                          TAG: /* Text */0,
                          _0: "Time Charge"
                        },
                        accessor: (function (f) {
                            return {
                                    TAG: /* Text */0,
                                    _0: f.time_charge
                                  };
                          })
                      },
                      tl: {
                        hd: {
                          column: {
                            TAG: /* Text */0,
                            _0: "Flat Surcharge"
                          },
                          accessor: (function (f) {
                              return {
                                      TAG: /* Text */0,
                                      _0: f.demand_surcharge
                                    };
                            })
                        },
                        tl: {
                          hd: {
                            column: {
                              TAG: /* Text */0,
                              _0: "Pickup Extra Charge"
                            },
                            accessor: (function (f) {
                                return {
                                        TAG: /* Text */0,
                                        _0: f.pickup_extra_charge
                                      };
                              })
                          },
                          tl: {
                            hd: {
                              column: {
                                TAG: /* Text */0,
                                _0: "Drop Extra Charge"
                              },
                              accessor: (function (f) {
                                  return {
                                          TAG: /* Text */0,
                                          _0: f.drop_extra_charge
                                        };
                                })
                            },
                            tl: {
                              hd: {
                                column: {
                                  TAG: /* Text */0,
                                  _0: "Helper Charges"
                                },
                                accessor: (function (f) {
                                    return {
                                            TAG: /* Text */0,
                                            _0: f.helper_charges
                                          };
                                  })
                              },
                              tl: {
                                hd: {
                                  column: {
                                    TAG: /* Text */0,
                                    _0: "Helper + 1 Labour Charges"
                                  },
                                  accessor: (function (f) {
                                      return {
                                              TAG: /* Text */0,
                                              _0: f.helper_labour
                                            };
                                    })
                                },
                                tl: {
                                  hd: {
                                    column: {
                                      TAG: /* Text */0,
                                      _0: "Waypoints"
                                    },
                                    accessor: (function (f) {
                                        return {
                                                TAG: /* Text */0,
                                                _0: f.waypoints
                                              };
                                      })
                                  },
                                  tl: {
                                    hd: {
                                      column: {
                                        TAG: /* Text */0,
                                        _0: "Waypoint Charge"
                                      },
                                      accessor: (function (f) {
                                          return {
                                                  TAG: /* Text */0,
                                                  _0: f.waypoint_charge
                                                };
                                        })
                                    },
                                    tl: {
                                      hd: {
                                        column: {
                                          TAG: /* Text */0,
                                          _0: "Road Tax"
                                        },
                                        accessor: (function (f) {
                                            return {
                                                    TAG: /* Text */0,
                                                    _0: f.road_tax
                                                  };
                                          })
                                      },
                                      tl: {
                                        hd: {
                                          column: {
                                            TAG: /* Text */0,
                                            _0: "Toll"
                                          },
                                          accessor: (function (f) {
                                              return {
                                                      TAG: /* Text */0,
                                                      _0: f.toll
                                                    };
                                            })
                                        },
                                        tl: {
                                          hd: {
                                            column: {
                                              TAG: /* Text */0,
                                              _0: "VAT"
                                            },
                                            accessor: (function (f) {
                                                return {
                                                        TAG: /* Text */0,
                                                        _0: f.vat
                                                      };
                                              })
                                          },
                                          tl: {
                                            hd: {
                                              column: {
                                                TAG: /* Text */0,
                                                _0: "Up Entry Charge"
                                              },
                                              accessor: (function (f) {
                                                  return {
                                                          TAG: /* Text */0,
                                                          _0: f.up_entry_charge
                                                        };
                                                })
                                            },
                                            tl: {
                                              hd: {
                                                column: {
                                                  TAG: /* Text */0,
                                                  _0: "Environmental Tax"
                                                },
                                                accessor: (function (f) {
                                                    return {
                                                            TAG: /* Text */0,
                                                            _0: f.environmental_tax
                                                          };
                                                  })
                                              },
                                              tl: {
                                                hd: {
                                                  column: {
                                                    TAG: /* Text */0,
                                                    _0: "Travel Fare"
                                                  },
                                                  accessor: (function (f) {
                                                      return {
                                                              TAG: /* Text */0,
                                                              _0: f.travel_fare
                                                            };
                                                    })
                                                },
                                                tl: {
                                                  hd: {
                                                    column: {
                                                      TAG: /* Text */0,
                                                      _0: "Loading Time"
                                                    },
                                                    accessor: (function (f) {
                                                        return {
                                                                TAG: /* Text */0,
                                                                _0: f.loading_time
                                                              };
                                                      })
                                                  },
                                                  tl: {
                                                    hd: {
                                                      column: {
                                                        TAG: /* Text */0,
                                                        _0: "Unloading Time"
                                                      },
                                                      accessor: (function (f) {
                                                          return {
                                                                  TAG: /* Text */0,
                                                                  _0: f.unloading_time
                                                                };
                                                        })
                                                    },
                                                    tl: {
                                                      hd: {
                                                        column: {
                                                          TAG: /* Text */0,
                                                          _0: "Porter Gold Savings"
                                                        },
                                                        accessor: (function (f) {
                                                            return {
                                                                    TAG: /* Text */0,
                                                                    _0: f.subscription_savings
                                                                  };
                                                          })
                                                      },
                                                      tl: {
                                                        hd: {
                                                          column: {
                                                            TAG: /* Text */0,
                                                            _0: "Referral Discount"
                                                          },
                                                          accessor: (function (f) {
                                                              return {
                                                                      TAG: /* Text */0,
                                                                      _0: f.referral_discount
                                                                    };
                                                            })
                                                        },
                                                        tl: {
                                                          hd: {
                                                            column: {
                                                              TAG: /* Text */0,
                                                              _0: "Coupon Discount"
                                                            },
                                                            accessor: (function (f) {
                                                                return {
                                                                        TAG: /* Text */0,
                                                                        _0: f.coupon_discount
                                                                      };
                                                              })
                                                          },
                                                          tl: {
                                                            hd: {
                                                              column: {
                                                                TAG: /* Text */0,
                                                                _0: "Cashback"
                                                              },
                                                              accessor: (function (f) {
                                                                  return {
                                                                          TAG: /* Text */0,
                                                                          _0: f.cashback
                                                                        };
                                                                })
                                                            },
                                                            tl: {
                                                              hd: {
                                                                column: {
                                                                  TAG: /* Text */0,
                                                                  _0: "Courier Fee"
                                                                },
                                                                accessor: (function (f) {
                                                                    return {
                                                                            TAG: /* Text */0,
                                                                            _0: f.courier_fee
                                                                          };
                                                                  })
                                                              },
                                                              tl: {
                                                                hd: {
                                                                  column: {
                                                                    TAG: /* Text */0,
                                                                    _0: "Fare"
                                                                  },
                                                                  accessor: (function (f) {
                                                                      return {
                                                                              TAG: /* Text */0,
                                                                              _0: f.fare
                                                                            };
                                                                    })
                                                                },
                                                                tl: {
                                                                  hd: {
                                                                    column: {
                                                                      TAG: /* Text */0,
                                                                      _0: "Rounding"
                                                                    },
                                                                    accessor: (function (f) {
                                                                        return {
                                                                                TAG: /* Text */0,
                                                                                _0: f.preTripRoundOff
                                                                              };
                                                                      })
                                                                  },
                                                                  tl: /* [] */0
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        };
}

function OrderFareTable(Props) {
  var order_fare = Props.order_fare;
  var order_details = Props.order_details;
  var match = CountryContext.useContext(undefined);
  var currency = CountryConfig.getSymbol(match.country);
  var order_fares = OrderFareTableVm.getVm(order_fare, order_details, currency);
  return React.createElement(TableComponent$Catalyst.make, {
              columns: getTableColumnsSchema(undefined),
              rowData: order_fares,
              className: "c-nlo-table"
            });
}

var make = OrderFareTable;

export {
  getTableColumnsSchema ,
  make ,
  
}
/* react Not a pure module */
